$(document).ready(() => {
  const isBaSPage = $('html').hasClass('page-build_a_system')
  const isLifeproofPage = $('html').hasClass('page-lifeproof_flow')
  if (!isBaSPage && !isLifeproofPage) return;

  const lifeproofPageBundle = 7
  const defaultColor = "Eucalyptus"
  const noLabelText = "No Label"
  const confirmDeleteText = "Are you sure you want to remove?"
  const addToCartButtonText = "Add to Cart"
  const EditButtonText = "Update"
  const stepProgressBarPoints = (()=> {
    const stepPercentage = $('.step-progress').data()
    const arrayOfPercentage = Object.keys(stepPercentage).map((key) => stepPercentage[key])
    return arrayOfPercentage.sort((a, b) => a-b)
  })()
  const starterLabelSelectizeBaSPlugin = 'nodeselect'
  const starterLabelSelectizeUserCreatedTagClass = 'user-created-tag'
  const lastStep = 6
  const delayOnLoadingStep = 7000
  const savePopUpDelay = 30000
  const BaSDefaultSize = "Medium"
  const extenderName = "Extender"
  const tileName = "Tile"
  const smallSizeName = "Small"
  const mediumSizeName = "Medium"
  const largeSizeName = "Large"
  const extenderTitle = "The Extender"
  const defaultDiscountText = "You’re getting free US ground shipping"
  const defaultVariantDiscount = 5
  const largeVariantDiscount = 10
  const lifeproofDiscount = "lifeproof"
  const isBeforeLoadingStep = () => BaSStep < steps.indexOf('loading') + 1

  const steps = ['bundle', 'label', 'loading', 'sizes', 'color', 'finalize']
  const blankLabel = "*Blank Label*"
  const editorTitleOnCreate = "Add to your System"
  const editorTitleOnEdit = "Edit Your System"
  const selectizeMaxItemsSelected = "Remove a label to add more"
  const sizeCopy = {
    "Small": "0.56 fl oz and fits easily in pockets and small bags. Stacks vertically.",
    "Medium": "1.32 fl oz and designed to be the most versatile. Magnetically connects vertically and horizontally.",
    "Large": "2.75 fl oz and TSA-compliant. Magnetically connects vertically and horizontally."
  }
  const productColorValues = ["Charcoal", "Petal", "Lavender", "Sand", "Terracotta", "Pacific", "Arctic", "Atlantic", "Pine", "Sage", "Eucalyptus", "5PM", "6PM", "7PM", "Blush","Rosa","Plum"]

  let BaSStep = 1
  let isEdit = false
  let keyOfEdit = 0
  let currentWindowWidth = 0
  let isSoldOut = false

  const swiperProps = {
    observer: true,
    slidesPerView: 1,
    spaceBetween: 8,
    pagination: {
      el: ".swiper-pagination",
      type: 'bullets',
      clickable: true
    },
  }
  new Swiper ('[bas-pre-made-swiper]', swiperProps)
  new Swiper ('[bas-how-to-swiper]', { ...swiperProps, navigation: { nextEl: '.how-to-swiper-next', prevEl: '.how-to-swiper-prev' }, spaceBetween: 16 })
  const BaSSwiper = new Swiper ('[bas-select-starter-color]', swiperProps)
  new Swiper ('.bas-reviews-swiper-container', {
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
      invert: true,
    },
    keyboard: true,
    freeMode: false,
    threshold: 1,
    longSwipes: false,
    slidesPerRow: 'auto',
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: true
    }
  });

  $(".build-a-system-calculator").sortable({
    items: "> div:gt(0)",
    placeholder: "ui-state-highlight item"
  });

  const BaSCalculator = $(".build-a-system-calculator")
  if (!isDesktop()) {
    BaSCalculator.sortable( "disable" )
  }

  $( window ).on('resize', function() {
    const BaSCalculator = $(".build-a-system-calculator")
    if (isDesktop()) return BaSCalculator.sortable( "enable" );

    BaSCalculator.sortable( "disable" )
  });

  $(".build-a-system-calculator").disableSelection();
  
  $('.item').find('.color-options label').map((i, el) => {
    $(el).removeAttr('for')
    $(el).prev().removeAttr('id')
  })

  Selectize.define(starterLabelSelectizeBaSPlugin, function () {
    const self = this;
    const { setup } = self;
    this.setup = function () {
      setup.apply(self, arguments);
      // Intercept default handlers
      self.$dropdown.off('mousedown click', '[data-selectable]').on('mousedown', '[data-selectable]', function (e) {
        const $target = $(e.currentTarget)
        const value = $target.data('value');
        if (self.items.indexOf(value) !== -1) {
          e.preventDefault();
          e.stopPropagation();
          self.removeItem(value);
          $target.removeClass('selected')
          return false;
        }
        return self.onOptionSelect.apply(self, arguments);
      });
    }
  })

  const BaSSelectize = {
    maxItems: 7,
    hideSelected: false,
    openOnFocus: true,
    ignoreBlur: true,
    create: function(input) {
      return {
        value: input,
        text: input,
        className: starterLabelSelectizeUserCreatedTagClass
      }
    },
    onClear: function() {
        $('.selected-items-list').empty();
        setMainImgLabels()
    },
    plugins: [starterLabelSelectizeBaSPlugin],
    onChange: function(value) {
        $('.count-of-selected-items').text(value.length);
        setMainImgLabels()
        const attr = $(this.$input).attr('data-starter-label-selectizeBaS')
        if (typeof attr !== 'undefined' && attr !== false) {
          const items = $('.selected-items-list .selected-item ').toArray().map(q => $(q).data())
          const numberOfLabels = items.length
          localStorage.setItem(localStorageKeys.BAS.LABELS, JSON.stringify(items))
          $('.title-nothing-selected').toggle(numberOfLabels === 0)
          $('.title-selected').toggle(numberOfLabels > 0)
        } else {
          updateEditorLabelPreview(value)
        }
        this.settings.setPlaceholder(this)
    },
    onItemAdd: function(value, $item){
      $item.addClass('selected');
      const $selectedItemsList = $('.selected-items-list');
      const itemClass = $item.hasClass(starterLabelSelectizeUserCreatedTagClass) ? starterLabelSelectizeUserCreatedTagClass : '';
      const $selectedItem = $('<div/>', {'class': `selected-item ${itemClass}`, 'html': $item.html(), 'data-value': value, 'data-customize': !!itemClass});
      const $removeBtn = $('<button/>', {'class': 'remove-btn', 'html': ''});
      $removeBtn.on('click', () => {
        const selectize = $item.closest('.label-inner').find('select').data('selectize');
        selectize.removeItem(value);
        $selectedItem.remove();
      });
      $selectedItem.append($removeBtn.clone(true, true));
      this.$control_input.prop('readonly', true)
      if (isStarterSelectize(this)) {
        $selectedItemsList.append($selectedItem);
      }
      this.settings.setPlaceholder(this)
    },
    onItemRemove: function(value){
      const $selectedItemsList = $('.selected-items-list');
      const $selectedItem = $selectedItemsList.find(`.selected-item[data-value="${value}"]`);
      if ($selectedItem.hasClass(starterLabelSelectizeUserCreatedTagClass)) {
        this.removeOption(value)
        this.$dropdown.find(`[data-value="${value}"]`).remove()
      }
      if (isStarterSelectize(this)) {
        $selectedItem.remove();
      }
      this.$control_input.prop('readonly', true)
      this.settings.setPlaceholder(this)
    },
    createFilter: function(input) {
      const regexp = new RegExp('^' + input, 'i');
      return (item) => regexp.test(item.text);
    },
    onInitialize: function() {
      this.$control_input.parent().addClass('selectize-search-icon');
    },
    render: {
      option: function (data) {
        const $removeBtn = $(`<button data-value="${data.value}" class="remove-select-btn"></button>`);
        let additionalClass = data.value === 'label_free' ? ' custom-selectize-label' : '';
        if (data.disabled) additionalClass += ' disabled';
        const $item = $(`<div class="option${additionalClass} ${data.is_author ? 'is_author' : ''} ${data.className}"  data-selectable="" data-customize="${data.customize}" data-value="${data.value}"></div>`);
        $item.append($removeBtn);
        if (data.value === 'label_araki') $item.prepend(`<span>${data.text}</span><span class="arrow ico-chevron-down"></span>`)
        else if (isIcon(data.value)) $item.prepend(`<img src="${data.url}1" style="width: 1.5rem;">`)
        else if (isGoldenHour(data.value)) $item.prepend(`<span class="color-option color-swatch--${data.value.toLowerCase()}"></span>${data.value}`)
        else $item.prepend(data.text);
        return $item
      },
      item: function(data, escape) {
        const $item = $(`<div class="item ${escape(data.className)}" data-labelmessage="${data.text}" data-value="${data.value}"></div>`);
        $item.append(isIcon(data.value) ? `<img src="${data.url}1">` : data.value);
        return $item;
      },
      ...selectizeHelper.render
    },
    setPlaceholder: function(self) {
      const dropDownIsOpen = self.$dropdown.is(":visible")
      const placeholder = (() => {
        if (self.settings.maxItems === self.items.length && self.$control_input.attr('id') === 'topA0-selectized') return selectizeMaxItemsSelected
        if (dropDownIsOpen) return placeholderOnLebelSelectizeOpen
        return self.settings.placeholder
      })

      self.$control_input.attr('placeholder', placeholder);

      $('#topA0-selectized').removeClass('visible-placeholder')
      if (self.settings.maxItems === self.items.length) {
        $('#topA0-selectized').addClass('visible-placeholder')
      }

    },
    onDropdownOpen: function() {
      this.$control_input
        .focus()
        .blur()
        .prop('readonly', true)
        .on('mousedown', function() {
          $(this).prop('readonly', false);
        });
      this.settings.setPlaceholder(this)
      $('.selectize-dropdown').addClass('open')
    },
    onDropdownClose: function() {
      this.settings.setPlaceholder(this)
    },
    onBlur: function() {     
      if ($('.next-step-button').hasClass('hover')) {
        this.$control_input.focus();
        return
      }
      this.$control_input.removeClass('focus')
      this.settings.setPlaceholder(this);
      $('.selectize-dropdown').removeClass('open')
    }
  }

  $('.next-step-button').mouseover(() => {
    $('.next-step-button').addClass('hover')
  })

  $('.next-step-button').mouseout(() => {
    $('.next-step-button').removeClass('hover')
  })

  function isStarterSelectize(self) {
    const attr = $(self.$input).attr('data-starter-label-selectizeBaS')
    return typeof attr !== 'undefined' && attr !== false;
  }

  const selectStarterLabelSelectize = $('[data-starter-label-selectizeBaS]').selectize(BaSSelectize);
  const currentItemLabelSelectize = $('select[data-build-selectizeBaS]').selectize({ ...BaSSelectize, maxItems: 1 });
  $('[data-starter-label-selectizeBaS]').data('selectize').open()

  const observer = new MutationObserver(function(mutations) {
    mutations.filter(mutation => $(mutation.target).prop(mutation.attributeName).includes('focus'))
    if (!mutations.length) return

    $('.selectize-dropdown').addClass('open')
  });
  observer.observe($('.select-starter-labels-input-wrapper .selectize-input')[0], {
    attributes: true,
    attributeFilter: ['class']
  });

  $('.selectize-control input:not([type="select-multiple"])').attr('readonly','readonly')
  $('input[type="select-multiple"]').on('click', function(e) {
    $(this).prop('readonly', false)
    e.stopPropagation();
    e.preventDefault();
  })
  $('input[type="select-one"]').on('click', function(e) {
    $('[data-build-selectizebas]').data('selectize').clear()
    $(this).prop('readonly', false)
    e.stopPropagation();
    e.preventDefault();
  })

  $('.pre-made-bundles-group, .select-starter-labels-container').each(function () {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        $(entry.target).closest('.bas-step').find('.next-step-button.mobile-only').toggle(!entry.isIntersecting)
      })
    })
    observer.observe(this)
  })

  $('.build-a-system-header').each(function () {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        $(entry.target).find('.button-wrapper button').toggleClass('fixed', !entry.isIntersecting)
      })
    })
    observer.observe(this)
  })

  $('.build-a-system-calculator').on('click', '> .item:not(.add-new-bundle-item)', function (e) {
    const currentStep = Number($('html').attr('bas-step'))
    if ($(e.target).closest('.tooltip-icon, .edit, .icons').length) return

    const $currentTarget = $(e.currentTarget)
    $currentTarget.find('.action.edit').click()
    $('.current-item .settings .title span').html($currentTarget.find('.label').clone())

    if (currentStep === steps.indexOf('sizes') + 1) {
      const {label, size} = $currentTarget.data()
      updateTitleTooltip(label, size)
    }
  })

  $('.helper-drop-down .title').click(e => {$(e.target).closest('.helper').toggleClass('active')})
  $('.pre-made-bundles .item').click((e) => {
    const allItems = $('.pre-made-bundles.top-pick .item')
    allItems.removeClass('active')
    const item = $(e.target).closest('.item')
    const index = allItems.index(item)
    const numberOfLabels = Number(item.data('number_of_capsules'))
    const starterLabelSelectize = $('[data-starter-label-selectizeBaS]').data('selectize')
    $('.max-count-of-selected-items').text(numberOfLabels)
    starterLabelSelectize.settings.maxItems = numberOfLabels
    starterLabelSelectize.clear()
    item.addClass('active')
    const colorDesc = item.data('select_color_description')
    $('.select_color_description').text(colorDesc)

    $('.pre-made-bundles .swiper-container').removeClass('active').eq(index).addClass('active')
    $('.pre-made-bundles .next-step-button').removeClass('disabled')
    $('.pre-made-bundles .bas-footer-reviews').hide()
    $('.pre-made-bundles .bas-footer-reviews').eq(index).show()
    localStorage.setItem(localStorageKeys.BAS.NUMBER_OF_CAPSULES, $(e.currentTarget).data('number_of_capsules'))
  })

  $('.save-your-system-pop-up img').click(function() {
    $(this).closest('.save-your-system-pop-up').hide()
  })
  $('#bas-save-selections-modal form').submit(async (e) => {
    e.preventDefault();
    const button = $(e.currentTarget).find('button')
    if (button.hasClass('disabled')) return

    button.addClass('disabled')
    const email = $('#bas-save-selections-modal input').val()
    const capsules = localStorage.getItem(localStorageKeys.BAS.CAPSULES)
    const { origin, pathname } = window.location
    const url = `${origin + pathname}?&step=${steps.at(-1)}&saved_json=${capsules}`
    const preview = await getPreviewUrl()
    $.post(`${backend_url}/api/bas_selections`, { url, email, preview });
    $('#bas-save-selections-modal .js-modal-close').click()
    button.removeClass('disabled')
  })

  $('.free-ship-progress-area.step-progress a').off('click');
  $('.free-ship-progress-area.step-progress a').click(function(e) {
    if ($(this).hasClass('active')) return
    e.stopPropagation()
    e.preventDefault()
    return false
  })

  $('.main-header .back-button').click(() => {
    history.back();
  })
  $('.select-starter-color, .pre-made-bundles, .build-a-system-header').find('.next-step-button').click(nextStep)
  function nextStep() {
    const link = document.createElement('a');
    link.href = `?step=${steps[BaSStep]}`;
    document.body.appendChild(link);
    link.click();    
  }
  $('.select-starter-labels .next-step-button').click((e) => {
    const curEl = $(e.currentTarget)
    if (curEl.hasClass('disabled')) return

    curEl.addClass('disabled').delay(0).queue((next) => {
      updateStep(1)
      curEl.removeClass('disabled')
      $('.loading-wrapper').addClass('active')
      $('.bas-main-wrapper > .step-progress-wrapper').hide()
      createCapsules()
      next();
    });

    // delay 5 sec according to the conditions of the task
    setTimeout(() => {
      localStorage.setItem(localStorageKeys.BAS.CAPSULES, '')
      nextStep()
    }, delayOnLoadingStep)
  })

  function defaultTooltipDescription(size) {
    if (size === 'Large') return 'The Large capsules holds up to 2.75 fl oz of product.'
    if (size === 'Medium') return 'The Medium capsules holds up to 1.32 fl oz of product.'
    return 'The Small holds up to .56 fl oz of product.'
  }

  $(document).on('click', '.build-a-system-calculator > .item .tooltip-icon', function() {
    const gap = 11;
    const {label, size} = $(this).closest('.item').data()
    const calcData = calculatorData.find((el) => el.product_type.toLowerCase().includes(label.toLowerCase().trim()))
    const tooltip = $('.tooltip');
    tooltip.find('.tooltip-text').text(calcData && calcData[size] ? calcData[size].description : defaultTooltipDescription(size))
    tooltip.show();
    const tooltipRect = tooltip[0].getBoundingClientRect();
    const tooltipIconRect = $(this).find('img')[0].getBoundingClientRect();
    const left = tooltipIconRect.x - tooltipRect.width / 2 + tooltipIconRect.width / 2
    const right = left + tooltipRect.width
    const leftCorrection = right > window.innerWidth ? right - window.innerWidth : 0
    tooltip.css({
      left: left - leftCorrection,
      top: tooltipIconRect.y - gap - tooltipRect.height
    });
  })

  $(document).on('click', (e) => {
    if ($(e.target).closest('.tooltip-icon').length || $(e.target).closest('.tooltip').length) return
    $('.tooltip').hide();
  })

  $(document).on('scroll', (e) => {
    $('.tooltip').hide();
  })

  function updateEditorLabelPreview(label) {
    const color = labelColorsByColor[$('.current-item .color-select input:checked').data('colorName')]
    const span = $(`.label-select-expand .hex-area`)
    updateLabel(span, color, label)
  }

  function createLabelsPreview (capsuleCount) {
    $('.bas-starter-labels-preview').remove()
    const labelArray = [...Array(capsuleCount).keys()].map(elem => `<span class="label-${elem+1}"></span>`).join('');
    const labelsMain = `<div class="build-your-${capsuleCount}-labels-main bas-starter-labels-preview">${labelArray}</div>`;
    $('.select-starter-labels-container .preview').append(labelsMain);
    setMainImgLabels()
  }

  function setMainImgLabels() {
    const placeholder = '<center>[your text <br> here]<center>'
    const placeholderPosition = 7 // in the future it may depend on the selected number of capsules, now it is for all 7
    const selectize = $('[data-starter-label-selectizeBaS]').data('selectize')
    const capsuleCount = Number($('.pre-made-bundles .item.active').data('number_of_capsules'))
    const color = labelColorsByColor[$('.select-starter-color input:checked').data('colorName')] || 'black'
    $(`.build-your-${capsuleCount}-labels-main > span`).html('')
    if (!selectize.items.length) {
      const span = $(`.build-your-${capsuleCount}-labels-main > span.label-${placeholderPosition}`)
      span.removeClass('araki')
      span.html(placeholder);
      span.css('color', color);
      return
    }

    selectize.items.forEach((label, i) => {
      const spanSelector = `.build-your-${capsuleCount}-labels-main > span.label-${i + 1}`;
      const span = $(spanSelector)
      updateLabel(span, color, label)
    })
  }

  function updateLabel(span, color, label) {
    if (isIcon(label)) {
      span.html('');
      const img = $($(`div.option[data-value="${label}"] > img`)[0]).clone();
      const imgSrc = img.attr('src');
      img.attr('src', imgSrc.replace('-black.svg',`-${color}.svg?`));
      img.attr('id', label);
      if (isArakiIcon(label)) {
        img.addClass('araki');
        span.addClass('araki')
      } 
      img.appendTo(span);
      return
    }
    span.removeClass('araki')
    span.html(parseLabel(label));
    span.css('color', color);
  }

  function updateStep(arg) {
    BaSStep += arg
    if (arg < 0 && BaSStep === lastStep - 1) BaSStep += arg
    if (BaSStep < 1) return history.back()

    if (BaSStep === lastStep) {
      setTimeout(() => {
        $('.save-your-system-pop-up').css('display', 'flex');
      }, savePopUpDelay)
    }
    $('html').attr('bas-step', BaSStep)
    $('.bas-step').hide()
    $(`.bas-step${BaSStep}`).show()
    window.scrollTo(0, 0);
    
    const $stepProgressBar = $('.free-ship-progress-area.step-progress')
    $stepProgressBar.parent().toggle(BaSStep < lastStep)
    updateFreeShipProgress(stepProgressBarPoints[BaSStep - 1], $stepProgressBar)
  }

  $('.select-starter-color .color-options input').change((e) => {
    const $container = $('.select-starter-color')
    const input = $(e.target)
    const colorIndex = input.data('color-index')
    const color = input.data('variant-name')
    $(`.swiper-container .swiper-slide:not(:has(video))`, $container).hide()
    $(`.swiper-container .${color}`, $container).show()
    $('.select-starter-labels .product-label-image').removeClass('active')
    $('.select-starter-labels .label-wrapper').each((i, el) => $(el).find('.product-label-image').eq(colorIndex).addClass('active'))
    $('.current-color-name', $container).html(e.target.value)
    $('.select-starter-labels .hex-graphics text').css('fill', labelColors[colorIndex]);
    $('.pre-made-bundle-images', $container).removeClass('active')
    $(`.pre-made-bundle-images[data-color="${color}"]`, $container).addClass('active')
    localStorage.setItem(localStorageKeys.BAS.COLOR, color)
    BaSSwiper[0].update();
  })

  $('.select-starter-labels-input-wrapper > img').on('mousedown', function (e) {
    e.stopPropagation();
    e.preventDefault();
    const selectizeWrapper = $(e.target).parent()
    const selectize = selectStarterLabelSelectize.data("selectize")
    const selectizeInput = $('.selectize-input input', selectizeWrapper)
    const selectizeDropdown = $('.selectize-dropdown', selectizeWrapper)
    if (selectizeWrapper.find('.focus').length) {
      selectizeInput.blur()
      selectizeDropdown.removeClass('open')
      return selectize.close()
    }

    selectizeInput.focus()
    selectizeDropdown.addClass('open')
    selectize.open()
  });

  $('.bas-recommendations .button').click((e) => {
    const { label, size, color } = $(e.target).closest('.item').data()
    createNewBaS({label, size, color: bundleColorValues[color - 1]})
    window.scrollTo(0, 0);
  });

  // Build a System Landing
  (function () {
    function intersectionHandler(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('element-show');
        }
      });
    }

    const options = {
      threshold: [0.5]
    };
    const observer = new IntersectionObserver(intersectionHandler, options);
    const elements = document.querySelectorAll('.build-a-system-routines');

    for (let elm of elements) {
      observer.observe(elm);
    }
  }());

  // Build a System Product
  // change select window

  $('.btn-add-capsule').click(() => {
    selectCapsule(createNewBaS())
  })

  $('.build-a-system-calculator').on('click', '.item .action.edit', (e) => {
    const item = $(e.target).closest('.item')
    $('.current-item').removeClass('is-new-capsule')
    return selectCapsule(item)
  })
  $('.build-a-system-calculator').on('click', '.item.add-new-bundle-item', () => createNewBaS())
  $('.build-a-system-calculator').on('click', '.close-actions-list', (e) => {
    $(e.target).closest('.actions-list').hide()
  })

  $('.build-a-system-calculator').on('click', '.open-actions-list', (e) => {
    $('.build-a-system-calculator .item .actions-list').hide()
    const $actionsList = $(e.currentTarget).parent().addClass('active').find('.actions-list')
    $actionsList.show("slide", { direction: isDesktop() ? "right" : "down" })
    if (!isDesktop()) {
      $('body').addClass('modal-open')
    }
  })

  $(document).on('click', (e) => {
    if ($(e.target).hasClass('open-actions-list')) return

    const icons = $('.build-a-system-calculator .item .icons')
    if (icons.hasClass('active')) {
      $('body').removeClass('modal-open')
    }
    icons.removeClass('active')
    $('.build-a-system-calculator .item .actions-list').hide()
  })

  $('.finish-editing').click(function() {
    if ($(this).hasClass('disabled')) return

    saveLabel()
    saveSize()
    saveColor()
    closeCurrentItem()
    generateDynamicBundleImage()
  })

  $('.current-item .expand-trigger').click((e) => {
    if ($(e.currentTarget).hasClass('active')) return

    $('.current-item .expand-trigger.active').removeClass('active').next().slideUp()
  })

  $('.close-current-item-window').click(closeCurrentItem)

  $('.current-item').click((e) => {
    if ($(e.target).closest('.item').length) return

    closeCurrentItem(e)
  })

  $('.current-item input').change(updateCurrentItemButton)
  function updateCurrentItemButton() {
    const $editor = $('.current-item')
    const colorSelected = $('.variant-input-wrap input:checked', $editor).length
    const $size = $('.size-select-item.active', $editor)
    const label = $('[data-build-selectizeBaS] option', $editor).val()?.trim()
    currentItemLabelSelectize.parent().find(`.option.selected:not([data-value="${label}"])`).removeClass('selected')
    const customLabel = $('.custom-label-container .custom-label', $editor).val()
    const labelSelected = label === 'customize' ? customLabel : label.length
    const isExtender = $size.find('span').attr('size') === extenderName
    $('.finish-editing', $editor).toggleClass('disabled', !(colorSelected && $size.length && (labelSelected || isExtender) && !isSoldOut))
    
    $(`.current-item .title .label svg image`).attr('opacity',0);
    if (isIcon(label) && !isExtender) {
      const opacity = label.includes('araki') ? "1" : "0.5"
      $('.current-item .title .label .text').hide()
      $(`.current-item .title .label svg image[id=${label}-black]`).attr('opacity',opacity);
    } else {
      $('.current-item .title .label .text').show()
      $('.current-item .title .label .text').html(isExtender ? extenderTitle : label || noLabelText);
    }
    calculateCurrentItemPrice()
  }

  function closeCurrentItem(e) {
    if (e && $(e.target).closest('.current-item.is-new-capsule').length) {
      $('.build-a-system-calculator .item.active').remove()
    }
    $('.build-a-system-calculator .item.active').removeClass('active')
    $('body').removeClass('modal-open')
    updateCurentItem()
    calculatePrice()
    saveChanges()
  }

  function saveChanges() {
    const data = $('.build-a-system-calculator > .item').toArray().map(el => {
      const elData = $(el).data()
      delete elData.sortableItem;
      return elData
    }).reverse()
    data.pop()
    localStorage.setItem(localStorageKeys.BAS.CAPSULES, JSON.stringify(data))
  }

  function selectCapsule(item, isNewItem = false) {
    $('.build-a-system-calculator > .item').removeClass('active')
    item.addClass('active')
    const label = item.data('label') || ''
    const customLabel = item.data('custom-label') || ''
    const color = item.data('color') || defaultColor
    const size = item.data('size') || BaSDefaultSize
    
    if (!label) {
      $('.current-item svg > *').attr('opacity', 0)
    }
    if (customLabel.length) {
      currentItemLabelSelectize.parent().find('.option.selected').removeClass('selected')
      currentItemLabelSelectize.data('selectize').addOption({ value: customLabel, text: customLabel, className: starterLabelSelectizeUserCreatedTagClass });
    }
    $('.product-template-build-a-system [data-build-selectizeBaS]').data('selectize').setValue(customLabel || label)
    $('.product-template-build-a-system input.custom-label').val(customLabel)
    $(`.product-template-build-a-system [data-value=${color}]`).click()
    $(`.size-select-item:has(span[size="${size}"])`).click()
    $('.current-item .settings .title span').html(isNewItem ? editorTitleOnCreate : item.find('.label').clone())
    $('.affirm-message').eq(1).html($('.affirm-message').eq(0).html())
    $('.affirm-modal-trigger').eq(1).click(() => $('.affirm-modal-trigger').eq(0).click())
    updateCurentItemImage()
    updateCurentItem()
    $('body').addClass('modal-open')
  }

  // select size
  $('.size-select-item').click((e) => {
    const currentStep = Number($('html').attr('bas-step'))
    const editorItem = $('.current-item > .item')
    const target = $(e.target).closest('.size-select-item')
    const value = target.find('span').attr('size')
    const BaS = target.closest('.item')
    const $labelExpand = $('.label-select-expand')
    BaS.find('.size-select-item ').removeClass('active')
    target.addClass('active')
    const color = BaS.find('.variant-input-wrap input:checked').val() || defaultColor
    updateEditorImage(color, value)
    updateCurrentItemButton()
    const label = editorItem.find('[data-build-selectizeBaS] option').val()?.trim()

    if (currentStep !== steps.indexOf('color') + 1) {
      updateTitleTooltip(label, value)
    }
    $('.size-copy', editorItem).text(sizeCopy[value] || '')

    if (value === extenderName) {
      $labelExpand.addClass('disabled').find('.expand-content').slideUp()
      return
    }
    $labelExpand.removeClass('disabled')
  })

  function updateTitleTooltip(label, size) {
    const calcData = calculatorData.find((el) => el.product_type.toLowerCase().includes(label.toLowerCase().trim()))
    const tooltipText = calcData && calcData[size] ? calcData[size].description : defaultTooltipDescription(size)
    $('.current-item .settings .title .info-tooltip').text(tooltipText)
  }


  $(window).scroll(() => {
    const tooltip = $('#tooltip')
    const topOffSet =  tooltip.offset().top
    const viewportHeight = $(window).scrollTop()
    const threshold = 1.2
    if(topOffSet < viewportHeight * threshold) return tooltip.find('.info-tooltip').addClass('reversed')

    tooltip.find('.info-tooltip').removeClass('reversed')
  })

  function saveSize() {
    const editorItem = $('.current-item > .item')
    const value = editorItem.find('.size-select-item.active span').attr('size')
    $('.build-a-system-calculator .item.active').data('size', value)
    $('.build-a-system-calculator .item.active .size').text(getNewBaSName(value))
    updateCurentItemImage()
  }

  $('.apply-color-to-all-button').click(() => {
    $('.apply-color-to-all-confirmation-wrapper').removeClass('hidden')
  })

  $('.apply-color-to-all-confirmation-wrapper button').click(() => {
    $('.apply-color-to-all-confirmation-wrapper').addClass('hidden')
  })

  $('.apply-color-to-all-confirm').click(() => {
    const color = $('.current-item .item').find('.variant-input-wrap input:checked').val()
    const items = $('.build-a-system-calculator .item:not(.add-new-bundle-item)')
    items.data('color', color)
    $('.color .circle', items).attr('data-color', color)

    items.each((i, el) => {
      const $item = $(el)
      const size = $item.data('size') || BaSDefaultSize
      const colorIndex = bundleColorValues.indexOf(color) + 1
      $('.image img', $item).attr('src', `${image_service_url}/api/image?is_single=true&capsules=${colorIndex}&size=${size.toLowerCase()}&cropped=true`)
    })
    saveChanges()
  })

  // select label
  currentItemLabelSelectize.on('change', updateCurrentItemButton)
  function saveLabel() {
    const editorItem = $('.current-item > .item')
    const value = editorItem.find('[data-build-selectizeBaS] option').val()?.trim()
    const opacity = value.includes('araki') ? "1" : "0.5"
    const size = $('.current-item > .item .size-select-item.active span').attr('size')
    const isCustomize = $('.current-item [data-build-selectizeBaS]').closest('.label-inner').find('.selectize-input .user-created-tag').length
    $('.build-a-system-calculator .item.active .label').toggleClass('hidden', size === extenderName);

    if (!value)
      return $('.build-a-system-calculator .item.active .label .text').html(noLabelText)

    $('.build-a-system-calculator .item.active .label svg > *').attr('opacity', 0)
    $('.build-a-system-calculator .item.active').data('label', value)
    if (isIcon(value)) {
      $('.build-a-system-calculator .item.active .label .text').hide()
      $(`.build-a-system-calculator .item.active .label svg image[id=${value}-black]`).attr('opacity',opacity);
    } else {
      $('.build-a-system-calculator .item.active .label .text').show()
      $('.build-a-system-calculator .item.active .label .text').html(value || noLabelText);
    }
    if (isCustomize) {
      $('.build-a-system-calculator .item.active').data('label', 'customize')
      $('.build-a-system-calculator .item.active').data('custom-label', value)
      $('.build-a-system-calculator .item.active .label .text').html(value || noLabelText);
    } else {
      $('.build-a-system-calculator .item.active').data('custom-label', '')
    }
  }

  //select color
  $('.current-item .color-options input').change((e) => {
    const BaS = $('.current-item .item')
    const limitedColors = ["Arctic","Atlantic","Sage","Pine","5PM","6PM"]
    const input = BaS.find('.variant-input-wrap input:checked')
    const value = input.val()
    const colorIndex = input.data('color-index')
    $('.current-item .product-label-image').removeClass('active');
    $('.current-item .product-label-image').eq(colorIndex).addClass('active');
    BaS.find('.label-select .hex-graphics text').css('fill', labelColors[colorIndex]);
    const size = BaS.find('.size-select-item.active span')?.attr('size') || BaSDefaultSize
    const label = $('.current-item [data-build-selectizeBaS] option').val()?.trim()
    $('.color-select-expand .expand-value').text(value)

    if (limitedColors.includes(value)) {
      if (value === '7PM') {
        $('.expand-trigger').addClass('limited')
        $('.color-limited-edition').text('Made To Order')
      } else {
        $('.expand-trigger').addClass('limited')
        $('.color-limited-edition').text('Limited Edition')
      }
    } else {
      $('.expand-trigger').removeClass('limited')
    }



    updateEditorImage(value, size)
    updateSizesPreviews()
    updateEditorLabelPreview(label)
    expectedToShipWarning()
  })

  function expectedToShipWarning() {
    const BaS = $('.current-item .item')
    const size = BaS.find('.size-select-item.active span').attr('size')
    const color = BaS.find('.variant-input-wrap input:checked').val()
    const productType = getShadowProductType(size)
    const sku = getShadowProduct(productType, color, size)?.sku
    $('.cart-expected-to-ship', BaS).toggle(metafields.airf.expected_to_ship_sku.includes(sku))
    isSoldOut = false
    $('.cart-expected-to-ship', BaS).html(metafields.airf.expected_to_ship_text)

    if (metafields.airf.sold_out_sku.includes(sku)) {
      isSoldOut = true
      $('.cart-expected-to-ship', BaS).text('SOLD OUT')  
    } 

    updateCurrentItemButton() 
  }

  function saveColor() {
    const value = $('.current-item .item').find('.variant-input-wrap input:checked').val()
    $('.build-a-system-calculator .item.active').data('color', value)
    $('.build-a-system-calculator .item.active .color .circle').attr('data-color', value)
    updateCurentItemImage()
  }

  function updateCurentItemImage() {
    const color = $('.build-a-system-calculator .item.active').data('color') || defaultColor
    const size = $('.build-a-system-calculator .item.active').data('size') || BaSDefaultSize
    const colorIndex = bundleColorValues.indexOf(color) + 1
    $('.build-a-system-calculator .item.active .image img').attr('src', `${image_service_url}/api/image?is_single=true&capsules=${colorIndex}&size=${size.toLowerCase()}&cropped=true`)
    $('.build-a-system-calculator .item.active .image img').attr('class', `${getNewBaSName(size).replaceAll(' ', '_')}`)
    updateEditorImage(color, size)
  }

  function updateEditorImage(color, size) {
    if (isBeforeLoadingStep()) return

    const curSizeAdditionalMedia = BaSImagesByColorAndSize[size.toLowerCase()]
    const productImages = [...curSizeAdditionalMedia.product]
    const media = [...curSizeAdditionalMedia.media]
    if (productImages.length > bundleColorValues.length ) {
      productImages.slice(bundleColorValues.length).reverse().forEach((el) => {
        media.push({single_image: el})
      })
    }
    $('[data-main-photos-swiper-thumbs] video, [data-main-photos-swiper] video').each((i, el) => {
      const video = $(el)[0]
      video.pause()
      video.removeAttribute('src');
      video.load();
    })
    $('[data-main-photos-swiper-thumbs] .swiper-slide:not(:has(.custom-image))').remove()
    $('[data-main-photos-swiper] .swiper-slide:not(:has(.custom-image))').remove()
    const productColorIndex = productColorValues.indexOf(color)
    
    $('.capsule-image .custom-image').attr('src', productImages[productColorIndex])
    addImage = (image) => {
      if (image?.length > 0) {
        const swiperImage = $(`
          <div class="swiper-slide">
            <img src="${image}" alt="preview thumbs {{ forloop.index }}">
          </div>
        `)
        $('[data-main-photos-swiper-thumbs] .swiper-wrapper').append(swiperImage)
        $('[data-main-photos-swiper] .swiper-wrapper').append(swiperImage.clone())
      }
    }
    addVideo = (src, poster) => {
      const swiperEl = $(`<div class="swiper-slide custom-video additional-media" data-scroll-block></div>`)
      const video = $('<video />', {
        id: 'video',
        src,
        playsinline: true,
        muted: true,
        poster: poster,
        class: 'play-on-intersection',
        type: 'video/mp4',
      });
      swiperEl.append(video)
      $('[data-main-photos-swiper-thumbs] .swiper-wrapper').append(swiperEl)
      $('[data-main-photos-swiper] .swiper-wrapper').append(swiperEl.clone())
    }
    media.forEach((media) => {
      const currentMedia = media[productColorIndex]
      if (currentMedia?.video) {
        addVideo(currentMedia.video.url, currentMedia.video.poster)
      } else {
        media.video ? addVideo(media.video.url, media.video.poster) : addImage(media.single_image || currentMedia)
      }
    })
    $('[data-main-photos-swiper-thumbs] video, [data-main-photos-swiper] video').each((i, el) => {
      const video = $(el)[0]
      video.muted = true
      video.autoplay = true
      video.loop = true
    })
  }

  $('#bas-confirm-modal .btn-confirm').click(() => {
    const {item, type} = $('#bas-confirm-modal').data()
    if (type !== "bas") return
    if (item === 'all') {
      calculatePrice()
      $('.build-a-system-calculator > .item:not(.add-new-bundle-item)').remove()
      return
    }

    item.remove()
    calculatePrice()
    generateDynamicBundleImage()
  })

  function createNewBaS({label, size, color, customLabel, openOnCreate = true} = {}) {
    if (isBeforeLoadingStep()) return

    const icons = $('.hidden-icons')
    const infoIcon = $('.hidden-icons .hidden')
    const colorIndex = bundleColorValues.indexOf(color || defaultColor) + 1
    const newItem = $(`
      <div class="item">
      <div class="tooltip-icon">${infoIcon.html()}</div>
        <div class="icons">
        <div class="action-overlay"></div>
          ${icons.html()}
        </div>
        <div class="label">
          <div class="text">No Label</div>
        </div>
        <div class="image">
          <img src="${image_service_url}/api/image?is_single=true&capsules=${colorIndex}&size=${(size || BaSDefaultSize).toLowerCase()}&cropped=true" class="${getNewBaSName(size).replaceAll(' ', '_')}">
        </div>
        <div class="size hidden">${getNewBaSName(size)}</div>
        <div class="color hidden"><div class="circle" data-color="${color || defaultColor}"></div></div>
      </div>`)
    const hex = $('svg.brick').eq(0).clone()
    hex.find('image').attr('opacity', 0);
    newItem.find('.label').append(hex)

    newItem.data('size', BaSDefaultSize)
    newItem.data('color', defaultColor)
    if (label) {
      newItem.data('label', label)
      newItem.find('.text').text(customLabel || label);
      if (isIcon(label)) {
        const opacity = label.includes('araki') ? "1" : "0.5"
        newItem.find('.label .text').hide()
        newItem.find(`.label svg image[id=${label.trim()}-black]`).attr('opacity',opacity);
      }
    }
    newItem.find('.label').toggleClass('hidden', size === extenderName);
    color && newItem.data('color', color);
    size && newItem.data('size', size);
    customLabel && newItem.data('custom-label', customLabel);

    $('.build-a-system-calculator').append(newItem)
    if (openOnCreate) {
      selectCapsule(newItem, true)
      $('.current-item').addClass('is-new-capsule')
    }

    calculatePrice()
    return newItem
  }

  $('.build-a-system-calculator').on('click', '.button-remove', (e) => {
    $('.js-modal-open-bas-confirm-modal').click()
    $('#bas-confirm-modal .modal__centered-header').text(confirmDeleteText)
    $('#bas-confirm-modal .modal__centered-copy').show()
    $('#bas-confirm-modal').data('item', $(e.target).closest('.item'))
    $('#bas-confirm-modal').data('type', 'bas')
  })

  $('.build-a-system-calculator').on('click', '.button-duplicate', (e) => {
    const item = $(e.target).closest('.item')
    const newItem = item.clone()
      .removeClass('active')
      .data('label', item.data('label'))
      .data('custom-label', item.data('custom-label'))
      .data('color', item.data('color'))
      .data('size', item.data('size'))
      item.after(newItem)
    calculatePrice()
    generateDynamicBundleImage()
  })

  $('.variant-input label').click((e) => {
    $(e.target).prev().click()
  })

  // Add BaS to Cart
  $('.add-to-cart').click(async(e) => {
    if ($('.add-to-cart').hasClass('disabled')) return

    let discount = isLifeproofPage ? 0 : BaSGetDiscount(calculatePrice())?.discount || 0
    const mainData = {
      items : [
        {
          id: build_a_system_main_id,
          quantity: 1,
          properties: getPropertiesAll()
        }
      ]
    }
    $('.add-to-cart').addClass('disabled')
    const items = mainData.items
    const timestamp = mainData.items[0].properties['Timestamp']
    
    $('.build-a-system-calculator > .item:not(.add-new-bundle-item)').map((i, el) => {
      const label = $(el).data('label')
      const customizeLabel = $(el).data('custom-label')
      const color = $(el).data('color')
      const size = $(el).data('size')
      const type = (label === 'customize' || isArakiIcon(label)) && size !== extenderName ? 'custom' : 'standard'
      const partDiscount = (() => {
        if (isLifeproofPage) return lifeproofDiscount
        if (size === largeSizeName && discount >= largeVariantDiscount) return largeVariantDiscount
        return discount > 0 ? defaultVariantDiscount : 0
      })()
      const findOptionText = `${type} / ${size} / ${partDiscount}`
      discount = discount - partDiscount
      $('#ProductSelect option').toArray().find((option) => {
        const curOptionText = $(option).text()
        if (curOptionText.includes(findOptionText)) {
          const id = $(option).val()
          const properties = getPropertiesSingle(el, timestamp)
          const item = existingShadowProductItem({id, properties}, items)
          if (item) {
            item.quantity += 1
            item.properties['Quantity'] += 1
          }
          else
            items.push({
              id,
              quantity: 1,
              properties
            })
          return true
        }
      })
      addShadowProducts(items, color, label, customizeLabel, 1, timestamp, size)
    })

    const resData = await $.post('/cart/add.js', mainData)
    if (isEdit) {
      await theme.cart.changeItem(keyOfEdit, 0)
      keyOfEdit = JSON.parse(resData).items[0].key
      return
    }
    $('body').trigger('updateCart')
  })
  
  function addShadowProducts(items, color, label, customLabel, quantity, timestamp, size) {
    const properties = {
      'Product': "build_a_system",
      'Color': color,
      'Label': label,
      'Custom Label': customLabel,
      'Quantity': quantity,
      'Parent Timestamp': timestamp,
    }
    const productType = getShadowProductType(size)
    const shadowCapsules = getShadowProduct(productType, color, size)?.id
    const item = {id: shadowCapsules, quantity, properties}
    const existingItem = existingShadowProductItem(item, items)
    if (existingItem) {
      existingItem.quantity += quantity
      existingItem.properties['Quantity'] += 1
    } else 
      items.push(item)
  }
  const getShadowProductType = (size) => {
    if (size === "Extender") return "extender"
    if (size === "Tile") return "flex_tile"
    return 'capsule'
  }

  function getPropertiesSingle (el, timestamp) {
    const data = {}
    const {isCustomize, label, customizeLabel, size, color} = getPropertiesHelper(el)
    data[`Parent Timestamp`] = timestamp
    data[`Custom Bundle Label`] = isCustomize ? customizeLabel : ''
    data[`Bundle Size`] = size
    data[`Bundle Color`] = color
    data[`Standard Bundle Label`] = isCustomize ? 'customize' : label
    data[`Quantity`] = 1
    return data
  }

  function getPropertiesHelper(el) {
    const label = $(el).data('label')
    const customizeLabel = $(el).data('custom-label')
    const color = $(el).data('color')
    const size = $(el).data('size')
    const isCustomize = label === 'customize'
    return {isCustomize, label, customizeLabel, size, color}
  }

  function getPropertiesAll () {
    const data = {}
    const items = $('.build-a-system-calculator > .item:not(.add-new-bundle-item)')
    const price = calculatePrice()
    data[`Timestamp`] = Date.now()
    data[`Count of items`] = items.length
    data[`URL For Edit`] = saveBaSToUrl()
    if (BaSGetDiscount(price) && !isLifeproofPage) {
      data[`Price Without Discount`] = parseFloat(price).toFixed(2)
    }
    items.map((index, el) => {
      const {isCustomize, label, customizeLabel, size, color} = getPropertiesHelper(el)
      data[`Standard Bundle Label ${ index + 1 }`] = isCustomize ? 'customize' : label
      data[`Custom Bundle Label ${ index + 1 }`] = isCustomize ? customizeLabel : ''
      data[`Bundle Size ${ index + 1 }`] = size
      data[`Bundle Color ${ index + 1 }`] = color
    })
    return data
  }

  function calculateCurrentItemPrice() {
    const size = $('.current-item .size-select-item.active span')?.attr('size')
    const label = $('.current-item [data-build-selectizeBaS] option').val()?.trim()
    const isCustomize = $('.current-item [data-build-selectizeBaS]').closest('.label-inner').find('.selectize-input .user-created-tag').length
    const type = (isCustomize || isArakiIcon(label)) && size !== extenderName ? 'custom' : 'standard'
    const findOptionText = `${type} / ${size}`
    $('#ProductSelect option').toArray().find((option) => {
      const curOptionText = $(option).text()
      if (curOptionText.includes(findOptionText)) {
        $('.current-item-price').text(Number(curOptionText.match(/\$(.*?)USD/)[1]))
        return true
      }
    })
  }

  function calculatePrice() {
    let price = 0
    const items = $('.build-a-system-calculator > .item:not(.add-new-bundle-item)')
    items.map((i, el) => {
      const item = $(el)
      const label = item.data('label')
      const size = item.data('size')
      const type = (label === 'customize' || isArakiIcon(label)) && size !== extenderName ? 'custom' : 'standard'
      const findOptionText = `${type} / ${size}`
      $('#ProductSelect option').toArray().find((option) => {
        const curOptionText = $(option).text()
        if (curOptionText.includes(findOptionText)) {
          const variantPrice = curOptionText.match(/\$(.*?)USD/)
          if (variantPrice)
            price += Number(curOptionText.match(/\$(.*?)USD/)[1]);
          else
            $('.build-a-system-header .add-to-cart').removeClass('disabled')
          return true
        }
      })
    })
    const discountedPrice = calculateDiscountedPrice(price)
    $('.add-to-cart .price').html(discountedPrice === price || isLifeproofPage ? price : `${calculateDiscountedPrice(price)} <s>$${price}</s>`)
    updateAddToCartButton()
    $('.capsules-count').text(`(${items.length})`)
    !isLifeproofPage && $('.discount-text').html(BaSGetDiscount(price)?.text || defaultDiscountText)
    return price
  }

  function calculateDiscountedPrice(price) {
    const rule = BaSDiscountRules.find((curRule) => price >= curRule.minPrice)
    return rule ? price - rule.discount : price;
  }

  function updateFreeShipProgress(price, container) {
    const dataAmountNeededFirst = Number(container.data('amount-needed-first'));
    const dataAmountNeededSecond = Number(container.data('amount-needed-second'));
    const dataAmountNeededThird = Number(container.data('amount-needed-third'));
    const dataAmountNeededFourth = Number(container.data('amount-needed-fourth'));
    const dataAmountNeededFifth = Number(container.data('amount-needed-fifth'));
    const barWidth = container.find(".free-ship-progress-bar").width();
    const firstLeft = Math.round(Number(container.find(".point-first").css("left").replace('px', '')) / barWidth * 100);
    const secondLeft = Math.round(Number(container.find(".point-second").css("left").replace('px', '')) / barWidth * 100);
    const thirdLeft = Math.round(Number(container.find(".point-third").css("left").replace('px', '')) / barWidth * 100);
    const fourthLeft = Math.round(Number(container.find(".point-fourth").css("left")?.replace('px', '')) / barWidth * 100);
    const fifthLeft = Math.round(Number(container.find(".point-fifth").css("left")?.replace('px', '')) / barWidth * 100);
    const goalNeeded = container.data('amount-needed');
    let percentage = Math.min(price * 100 / dataAmountNeededFirst * (firstLeft / 100), firstLeft);
    if (percentage >= firstLeft) {
      percentage = Math.min((price - dataAmountNeededFirst) * 100 / (dataAmountNeededSecond -dataAmountNeededFirst) * ((secondLeft - firstLeft) / 100) + percentage, secondLeft);
    }
    if (percentage >= secondLeft) {
      percentage = Math.min((price - dataAmountNeededSecond) * 100 / (dataAmountNeededThird - dataAmountNeededSecond) * ((thirdLeft - secondLeft) / 100) + percentage, thirdLeft);
    }
    if (!fourthLeft && percentage >= thirdLeft) {
      percentage = Math.min((price - dataAmountNeededThird) * 100 / (goalNeeded - dataAmountNeededThird) * ((100 - thirdLeft) / 100) + percentage, 100);
    }
    if (fourthLeft && percentage >= thirdLeft) {
      percentage = Math.min((price - dataAmountNeededThird) * 100 / (dataAmountNeededFourth - dataAmountNeededThird) * ((fourthLeft - thirdLeft) / 100) + percentage, fourthLeft);
    }
    if (fourthLeft && percentage >= fourthLeft) {
      percentage = Math.min((price - dataAmountNeededFourth) * 100 / (dataAmountNeededFifth - dataAmountNeededFourth) * ((fifthLeft - fourthLeft) / 100) + percentage, fifthLeft);
    }
    if (fourthLeft && percentage >= fifthLeft) {
      percentage = Math.min((price - dataAmountNeededFifth) * 100 / (goalNeeded - dataAmountNeededFifth) * ((100 - fifthLeft) / 100) + percentage, 100);
    }
    $('.progress', container).css('width', `${percentage}%`)

    const imgs = container.find('.point img')
    imgs.each(function() {
      $(this).attr('src', $(this).attr('src').replace(/-black-circle?/g, '-white'))
    })

    const setBlackIcon = (selector) => {
      const img = container.find(selector)
      img.attr('src', img.attr('src').replace(/(-black|-white)/g, '-black-circle'))
    }
    const setBlackIconChecked = (selector) => {
      const img = container.find(selector)
      img.attr('src', img.attr('src').replace(/(-black-circle|-white)/g, '-black'))
      img.closest('.point').addClass('active')
    }
    if (percentage > firstLeft) {
      setBlackIconChecked('.point-first img')
    }
    if (percentage === firstLeft) {
      setBlackIcon('.point-first img')
    }
    if (percentage > secondLeft) {
      setBlackIconChecked('.point-second img')
    }
    if (percentage === secondLeft) {
      setBlackIcon('.point-second img')
    }
    if (percentage > thirdLeft) {
      setBlackIconChecked('.point-third img')
    }
    if (percentage === thirdLeft) {
      setBlackIcon('.point-third img')
    }
    if (fourthLeft && percentage > fourthLeft) {
      setBlackIconChecked('.point-fourth img')
    }
    if (fourthLeft && percentage === fourthLeft) {
      setBlackIcon('.point-fourth img')
    }
  }

  function updateAddToCartButton() {
    const disabled = $('.build-a-system-calculator > .item:not(.add-new-bundle-item)').toArray().find((el) => {
      const {label, size} = $(el).data();
      if (size === extenderName) return false

      return !label?.length
    })
    if (disabled) 
      $('.add-to-cart').addClass('disabled')
    else
      $('.add-to-cart').removeClass('disabled')

    updateCurentItem()
  }

  function updateCurentItem() {
    const itemSelected = $('.build-a-system-calculator > .item.active');
    $('.current-item').toggleClass('active', !!itemSelected.length)
  }

  function openConstructor() {
    $('.build-a-system-calculator > .item:not(.add-new-bundle-item)').remove()
    const numberOfCapsules = $('.pre-made-bundles .item.active').data('number_of_capsules')
    const color = $('.select-starter-color .color-options input:checked').val()?.trim() || defaultColor
    const labelsJson = localStorage.getItem(localStorageKeys.BAS.LABELS)
    const labels = labelsJson?.length ? JSON.parse(labelsJson) : []
    for (let i = 0; i < numberOfCapsules; i++) {
      const {value, customize} = labels[i] || {value: blankLabel}
      const size = sizeByLabelObject[value] || BaSDefaultSize
      createNewBaS({label: customize ? 'customize' : value.trim(), size, color, customLabel: customize ? value : ''})
    }
    $('.build-a-system-calculator > .item.active').removeClass('active')
    updateCurentItem()
    calculatePrice()
    $('body').removeClass('modal-open')
  }

  function updateSizesPreviews() {
    const color = $('.current-item .color-options input:checked').val()
    const $sizes = $('.current-item .size-select .size-select-item span')

    $sizes.each((i, el) => {
      const size = $(el).attr('size')
      const $image = $(el).parent().find('img')
      const colorIndex = bundleColorValues.indexOf(color) + 1
      $image.attr('src', `${image_service_url}/api/image?is_single=true&capsules=${colorIndex}&size=${size.toLowerCase()}&cropped=true`)
    })
  }

  function saveBaSToUrl() {
    const items = $('.build-a-system-calculator > .item:not(.add-new-bundle-item)')
    const data = {
      isEdit: true,
      count: items.length,
      bundleLabels: [],
      bundleCustomLabels: [],
      bundleColors: [],
      bundlesizes: []
    }
    items.map((i, el) => {
      const {label, customizeLabel, size, color} = getPropertiesHelper(el)
      data.bundleLabels.push(label)
      data.bundleCustomLabels.push(customizeLabel || '')
      data.bundleColors.push(color)
      data.bundlesizes.push(size)
    })
    const { origin, pathname } = window.location
    return `${origin + pathname}?&${$.param( data )}`
  }

  function loadProductFromUrl() {
    const data = deparam(window.location.href.replace('?','?&'))
    Object.keys(data).forEach(key => data[key.replace('amp;', '')] = data[key])
    if (data['saved_json']) {
      const savedData = JSON.parse(data['saved_json'])
      updateStep(lastStep - BaSStep)
      return loadSavedCapsules(savedData)
    }
    loadStep(data['step'] || 'bundle')
    if (!data['product_handle'] && !data['isEdit']) return

    if (data['isEdit']) {
      isEdit = true
      keyOfEdit = data['item_key']
      const addToCartEls = $('.add-to-cart')
      addToCartEls.html(addToCartEls.html().replace(addToCartButtonText, EditButtonText))
    }

    const defaultColor = "Sand"
    const count = Number(basedOnProductMetafields?.cpsl_cnt || basedOnProductMetafields?.tile_cnt || data.count)
    const presetLabels = basedOnProductMetafields?.labels?.split(',') || data.bundleLabels
    const presetColors = basedOnProductMetafields?.colors?.split(',') || data.bundleColors
    const bundleCustomLabels = data.bundleCustomLabels
    const presetSizes = data.bundlesizes
    const selectizeOptions = Object.keys($('.premade-labels').eq(0).find('select').data('selectize').options)
    updateStep(lastStep - BaSStep)
    $('.shopify-section, #shopify-section-footer').show()
    for (let i = 1; i <= count; i++) {
      const label = presetLabels ? selectizeOptions.find((option) => option.toLowerCase().trim() === presetLabels[i- 1].toLowerCase().trim()) || '' : ''
      createNewBaS({
        label,
        size: presetSizes ? presetSizes [i - 1]: BaSDefaultSize,
        color: presetColors && presetColors[i - 1].trim() || data.color || defaultColor,
        customLabel: bundleCustomLabels && bundleCustomLabels[i - 1],
        openOnCreate: false
      })
    }
  }
  loadProductFromUrl()

  function loadStep(step) {
    if (isLifeproofPage && step === 'bundle') {
      step = 'label'
      localStorage.setItem(localStorageKeys.BAS.NUMBER_OF_CAPSULES, lifeproofPageBundle)
    }
    updateStep(steps.indexOf(step))

    const numberOfCapsules = Number(localStorage.getItem(localStorageKeys.BAS.NUMBER_OF_CAPSULES))
    if (numberOfCapsules) {
      $(`.pre-made-bundles .item[data-number_of_capsules="${numberOfCapsules}"]`).click()
    } else {
      $('.pre-made-bundles .item').eq(0).click()
    }
    if (step === 'bundle') return

    const $img = $('.select-starter-labels-container .swiper-slide img').eq(0)
    const colorIndex = bundleColorValues.indexOf(defaultColor) + 1
    const capsules = Array.from({length: numberOfCapsules}, () => colorIndex).join(',');
    const title = $('.pre-made-bundles .item.active').find('.name').text()
    $img.attr('src', `${image_service_url}/api/image?is_bas=true&capsules=${capsules}`)
    $('.select-starter-labels-container .swiper-slide').hide()
    $(`.select-starter-labels-container .swiper-slide[data-type="${title}"]`).show()
    createLabelsPreview(numberOfCapsules)

    const labelsJson = localStorage.getItem(localStorageKeys.BAS.LABELS)
    const labels = labelsJson?.length ? JSON.parse(labelsJson) : []
    const labelSelectize = $('[data-starter-label-selectizebas]').data('selectize')
    labels.forEach((el) => {
      if (el.customize) {
        labelSelectize.addOption({ value: el.value, text: el.value, className: starterLabelSelectizeUserCreatedTagClass });
      }
      labelSelectize.addItem(el.value)
    })
    if (step === 'label') return

    createCapsules()
    $('.shopify-section, #shopify-section-footer').show()
  }
  function createCapsules() {
    const BaSCapsulesJson = localStorage.getItem(localStorageKeys.BAS.CAPSULES)
    const BaSCapsules = BaSCapsulesJson?.length ? JSON.parse(BaSCapsulesJson) : []
    if (BaSCapsules.length) {
      loadSavedCapsules(BaSCapsules)
    } else {
      openConstructor()
    }
    saveChanges()
  }

  function loadSavedCapsules(list) {
    $('.build-a-system-calculator > .item:not(.add-new-bundle-item)').remove()
    list.forEach((el) => createNewBaS(el))
    $('.build-a-system-calculator > .item.active').removeClass('active')
    updateCurentItem()
    calculatePrice()
    $('.affirm-modal-trigger').eq(1).click(() => $('.affirm-modal-trigger').eq(0).click())
    $('body').removeClass('modal-open')
  }

  moveSectionsToFaq()

  function generateDynamicBundleImage() {
    const tileGroupSize = 14
    const leftOffset = isDesktop() ? 80 : 43
    const groupWidth = isDesktop() ? 91 : 51
    const stackedImageProp = {
      Small: 'smallStacked',
      Tile: 'tileStacked'
    }
    const allItems = $('.build-a-system-calculator .item:not(.add-new-bundle-item)').toArray().map((el) => $(el).data())
    const items = allItems.filter((el) => el.size !== tileName).sort((a, b) => a.size === smallSizeName ? 1 : b.size === smallSizeName ? -1 : 0) // remove the tiles and move all small capsules to the end of the array
    const tileItems = allItems.filter((el) => el.size === tileName) // tiles only
    const groups = chunkArray(tileItems, tileGroupSize);

    $('.dynamic-bundling-container').html('')
    for (let i = 0; i < items.length; i++) {
      const currItem = items[i]
      const stackedSizes = [mediumSizeName, smallSizeName]
      if (stackedSizes.includes(currItem.size) &&
        (items[items.length - 1].size === smallSizeName && i !== items.length - 1)
      ) {
        const group = [currItem, { ...items.pop() }]
        if (i !== items.length - 1 && currItem.size === smallSizeName) {
          group.push({ ...items.pop() })
        }
        groups.push(group)
        items.splice(i, 1)
        i = i - 1
        continue
      }
      groups.push([currItem])
    }
    const tiles = groups.filter(group => group[0].size === 'Tile')  
  
    const filtredGtoups = groups.filter(group => group[0].size !== 'Tile').sort(() => Math.random() - 0.5)
    filtredGtoups.push(...tiles)
    filtredGtoups.forEach((el, i) => {
      const groupEl = $('<div class="group"></div>')
      groupEl.css('z-index', groups.length - i + 1 )
      groupEl.css('left', i * leftOffset)
      el.forEach((groupItem, i) => {
        const imgType = i > 0 && el.length > 1 ? stackedImageProp[groupItem.size] : groupItem.size.toLowerCase()
        const imgUrl = dynamicBundlingImages[imgType][groupItem.color.toLowerCase()]
        groupEl.append(`<img class="${groupItem.size}" src="${imgUrl}" alt="Dynamic Bundle Image">`)
      })
      $('.dynamic-bundling-container').append(groupEl)
    })
    $('.dynamic-bundling-container').css('width', leftOffset * (groups.length - 1) +  groupWidth)
    $('.dynamic-bundling-container').append(`<img class="backlight" src="${dynamicBundlingImages.backlight}" alt="Dynamic Bundle Backlight">`)
    $('.dynamic-bundling-container').append(`<img class="shadow" src="${dynamicBundlingImages.shadow}" alt="Dynamic Bundle Shadow">`)
  }
  generateDynamicBundleImage()

  function chunkArray(array, chunkSize) {
    const result = [];
  
    for (let i = 0; i < array.length; i += chunkSize) {
      const chunk = array.slice(i, i + chunkSize);
      result.push(chunk);
    }
  
    return result;
  }
  $(window).on('resize', () => {
    windowWidth = $(window).width()
    if(windowWidth === currentWindowWidth) return
    
    currentWindowWidth = windowWidth
    generateDynamicBundleImage()
  })

  async function getPreviewUrl() {
    const previewElContainer = $(".dynamic-bundling-container")
    const padding = 30
    const canvas = await html2canvas(previewElContainer[0], {
      allowTaint: true,
      x: -padding,
      y: padding,
      height: previewElContainer.height(),
      width: previewElContainer.width() + padding * 2,
      backgroundColor: null
    })
    const image_c = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
    const blob = dataURItoBlob(image_c)
  
    const formData = new FormData();
    formData.append("file", blob);
    const image = await fetch(`${backend_url}/api/upload_file`, {method: "POST", body: formData }).then(response => response.json())
    return image.data.url
  }
})